import { agl, agr, aqf } from '@legion-theme/agree';
import { lgd, lgt } from '@legion-theme/logee';
import { lpe, qip } from '@legion-theme/fin';
import { oss, ptm } from '@legion-theme/ent';
import { mcr, msn, mtn } from '@legion-theme/ewz';
import { pjm, pjb } from '@legion-theme/edu';
import { pdm, lkp } from '@legion-theme/smb';
import { pli } from '@legion-theme/vpl';

import { theme as defaultTheme } from 'legion-ui';

const tribes = [
  {
    label: 'Default',
    options: [{ value: 'Default', label: 'Default Theme', content: defaultTheme }],
  },
  {
    label: 'AGREE',
    options: [
      { value: 'agl', label: 'Agree Livestock', content: agl },
      { value: 'agr', label: 'Agree Culture', content: agr },
      { value: 'aqf', label: 'Agree Fisheries', content: aqf },
    ],
  },
  {
    label: 'LOGEE',
    options: [
      { value: 'lgd', label: 'Logee Distribution', content: lgd },
      { value: 'lgt', label: 'Logee Transportation', content: lgt },
    ],
  },
  {
    label: 'FIN',
    options: [
      { value: 'lpe', label: 'Squad LPE', content: lpe },
      { value: 'qip', label: 'Squad QIP', content: qip },
    ],
  },
  {
    label: 'ENT',
    options: [
      { value: 'oss', label: 'Squad OSS', content: oss },
      { value: 'ptm', label: 'Squad Pertamina', content: ptm },
    ],
  },
  {
    label: 'EWZ',
    options: [
      { value: 'mcr', label: 'Squad MyCarrier', content: mcr },
      { value: 'msn', label: 'Squad MySooltan', content: msn },
      { value: 'mtn', label: 'Squad MyTEnS', content: mtn },
    ],
  },
  {
    label: 'EDU',
    options: [
      { value: 'pjm', label: 'Squad Pijar Mahir', content: pjm },
      { value: 'pjb', label: 'Squad Pijar Belajar', content: pjb },
    ],
  },
  {
    label: 'SMB',
    options: [
      { value: 'pdm', label: 'Squad PaDi', content: pdm },
      { value: 'lkp', label: 'Squad LKPP', content: lkp },
    ],
  },
  {
    label: 'VPL',
    options: [{ value: 'pli', label: 'Peduli Lindungi', content: pli }],
  },
];

const release = {
  keyNewRelease: '2.46.25',
  Date: '4 April 2023',
};

export { tribes, release };
